import type * as fhirTypes from "fhir/r4";
import { atom } from "jotai";

interface AmazonCarePlanPreviewState {
  open: boolean;
  motherEncounterId: string;
  carePlanId: string | undefined;
  childEncounterId: string;
  patientId: string;
  condition: fhirTypes.Condition | null;
}

export const amazonCarePlanPreviewAtom = atom<AmazonCarePlanPreviewState>({
  open: false,
  motherEncounterId: "",
  carePlanId: undefined,
  childEncounterId: "",
  patientId: "",
  condition: null,
});
